import type { SDKModule, SDKContext } from '../types';

export const ANIMATION_STYLE_CSS = `
@keyframes pt-fade        { from { opacity: 0 } to { opacity: 1 } }
@keyframes pt-slide-up    { from { opacity: 0; transform: translate3d(0, 24px, 0) }  to { opacity: 1; transform: none } }
@keyframes pt-slide-down  { from { opacity: 0; transform: translate3d(0, -24px, 0) } to { opacity: 1; transform: none } }
@keyframes pt-slide-left  { from { opacity: 0; transform: translate3d(-24px, 0, 0) } to { opacity: 1; transform: none } }
@keyframes pt-slide-right { from { opacity: 0; transform: translate3d(24px, 0, 0) }  to { opacity: 1; transform: none } }
@keyframes pt-zoom        { from { opacity: 0; transform: scale3d(.92,.92,.92) } 60% { opacity: 1 } to { opacity: 1; transform: none } }
@keyframes pt-pulse { 0%, 100% { transform: scale3d(1,1,1) } 50% { transform: scale3d(1.05,1.05,1.05) } }
@keyframes pt-flash { 0%, 40%, 100% { opacity: 1 } 20% { opacity: .4 } }
@keyframes pt-shake { 0%, 45%, 100% { transform: translate3d(0,0,0) } 9%, 27% { transform: translate3d(-4px,0,0) } 18%, 36% { transform: translate3d(4px,0,0) } }
@keyframes pt-bounce {
  from, 20%, 53%, to { animation-timing-function: cubic-bezier(.215,.61,.355,1); transform: translate3d(0,0,0) }
  40%, 43% { animation-timing-function: cubic-bezier(.755,.05,.855,.06); transform: translate3d(0,-20px,0) scaleY(1.06) }
  70% { animation-timing-function: cubic-bezier(.755,.05,.855,.06); transform: translate3d(0,-10px,0) scaleY(1.04) }
  80% { animation-timing-function: cubic-bezier(.215,.61,.355,1); transform: translate3d(0,0,0) scaleY(.96) }
  90% { transform: translate3d(0,-3px,0) scaleY(1.02) }
}
@keyframes pt-heartbeat { 0% { transform: scale(1) } 14% { transform: scale(1.15) } 28% { transform: scale(1) } 42% { transform: scale(1.15) } 70%, 100% { transform: scale(1) } }
@keyframes pt-fade-out       { from { opacity: 1 } to { opacity: 0 } }
@keyframes pt-slide-out-up   { from { opacity: 1; transform: none } to { opacity: 0; transform: translate3d(0, -24px, 0) } }
@keyframes pt-slide-out-down { from { opacity: 1; transform: none } to { opacity: 0; transform: translate3d(0, 24px, 0) } }
@keyframes pt-slide-out-left { from { opacity: 1; transform: none } to { opacity: 0; transform: translate3d(-24px, 0, 0) } }
@keyframes pt-slide-out-right{ from { opacity: 1; transform: none } to { opacity: 0; transform: translate3d(24px, 0, 0) } }
@keyframes pt-zoom-out       { from { opacity: 1; transform: none } to { opacity: 0; transform: scale3d(.92,.92,.92) } }
@keyframes pt-rotate  { from { transform: rotate(0) } to { transform: rotate(360deg) } }
@keyframes pt-float-y { 0%, 100% { transform: translateY(0) } 50% { transform: translateY(-8px) } }
@keyframes pt-float-x { 0%, 100% { transform: translateX(0) } 50% { transform: translateX(8px) } }
@keyframes pt-emph-scale { 0%, 100% { transform: scale(1) } 50% { transform: scale(var(--pt-ei, 1.1)) } }
.pt-anim-ready [data-pt-anim]:not(.pt-anim-in) { opacity: 0 }
[data-pt-anim].pt-anim-in {
  animation-duration: var(--pt-d, 500ms);
  animation-delay: var(--pt-dl, 0ms);
  animation-timing-function: var(--pt-e, cubic-bezier(.22, 1, .36, 1));
  animation-fill-mode: both;
}
[data-pt-anim="fade"].pt-anim-in        { animation-name: pt-fade }
[data-pt-anim="slide-up"].pt-anim-in    { animation-name: pt-slide-up }
[data-pt-anim="slide-down"].pt-anim-in  { animation-name: pt-slide-down }
[data-pt-anim="slide-left"].pt-anim-in  { animation-name: pt-slide-left }
[data-pt-anim="slide-right"].pt-anim-in { animation-name: pt-slide-right }
[data-pt-anim="zoom"].pt-anim-in        { animation-name: pt-zoom }
[data-pt-hover] {
  transition: transform var(--pt-hd, 200ms) cubic-bezier(.4,0,.2,1),
              box-shadow var(--pt-hd, 200ms) cubic-bezier(.4,0,.2,1),
              filter var(--pt-hd, 200ms) cubic-bezier(.4,0,.2,1);
}
[data-pt-hover="grow"]:hover,   [data-pt-hover="grow"].pt-hover-preview   { transform: scale(1.04) }
[data-pt-hover="lift"]:hover,   [data-pt-hover="lift"].pt-hover-preview   { transform: translateY(-4px); box-shadow: 0 10px 28px rgba(0,22,72,.16) }
[data-pt-hover="shadow"]:hover, [data-pt-hover="shadow"].pt-hover-preview { box-shadow: 0 8px 24px rgba(0,22,72,.2) }
[data-pt-hover="bright"]:hover, [data-pt-hover="bright"].pt-hover-preview { filter: brightness(.92) }
[data-pt-hover]:active { transform: scale(.97); transition-duration: 90ms }
[data-pt-loop].pt-loop-active { animation-iteration-count: infinite; animation-fill-mode: both }
[data-pt-loop="pulse"].pt-loop-active     { animation-name: pt-pulse;     animation-duration: var(--pt-ld, 1.6s); animation-timing-function: ease-in-out }
[data-pt-loop="flash"].pt-loop-active     { animation-name: pt-flash;     animation-duration: var(--pt-ld, 1.8s); animation-timing-function: ease-in-out }
[data-pt-loop="shake"].pt-loop-active     { animation-name: pt-shake;     animation-duration: var(--pt-ld, 2.4s); animation-timing-function: ease-in-out }
[data-pt-loop="bounce"].pt-loop-active    { animation-name: pt-bounce;    animation-duration: var(--pt-ld, 2s);   transform-origin: center bottom }
[data-pt-loop="heartbeat"].pt-loop-active { animation-name: pt-heartbeat; animation-duration: var(--pt-ld, 1.6s); animation-timing-function: ease-in-out }
[data-pt-loop].pt-loop-active.pt-loop-paused { animation-play-state: paused }
/* 强调（.pt-emph-in 触发；重复/方向/强度由 inline 变量驱动）*/
[data-pt-emph].pt-emph-in {
  animation-duration: var(--pt-ed, 600ms);
  animation-delay: var(--pt-edl, 0ms);
  animation-timing-function: var(--pt-ee, ease-in-out);
  animation-iteration-count: var(--pt-ec, 1);
  animation-direction: var(--pt-edir, normal);
  animation-fill-mode: both;
}
[data-pt-emph="scale"].pt-emph-in     { animation-name: pt-emph-scale }
[data-pt-emph="shake"].pt-emph-in     { animation-name: pt-shake }
[data-pt-emph="flash"].pt-emph-in     { animation-name: pt-flash }
[data-pt-emph="heartbeat"].pt-emph-in { animation-name: pt-heartbeat }
/* 退场（.pt-exit-out 触发，停在消失态）*/
[data-pt-exit].pt-exit-out {
  animation-duration: var(--pt-xd, 500ms);
  animation-delay: var(--pt-xdl, 0ms);
  animation-timing-function: var(--pt-xe, cubic-bezier(.22,1,.36,1));
  animation-fill-mode: forwards;
}
[data-pt-exit="fade-out"].pt-exit-out        { animation-name: pt-fade-out }
[data-pt-exit="slide-out-up"].pt-exit-out    { animation-name: pt-slide-out-up }
[data-pt-exit="slide-out-down"].pt-exit-out  { animation-name: pt-slide-out-down }
[data-pt-exit="slide-out-left"].pt-exit-out  { animation-name: pt-slide-out-left }
[data-pt-exit="slide-out-right"].pt-exit-out { animation-name: pt-slide-out-right }
[data-pt-exit="zoom-out"].pt-exit-out        { animation-name: pt-zoom-out }
/* 循环新增类型（沿用 .pt-loop-active gating；缓动用 --pt-le）*/
[data-pt-loop="rotate"].pt-loop-active  { animation-name: pt-rotate;  animation-duration: var(--pt-ld, 2s); animation-timing-function: var(--pt-le, linear) }
[data-pt-loop="scale"].pt-loop-active   { animation-name: pt-pulse;   animation-duration: var(--pt-ld, 1.6s); animation-timing-function: var(--pt-le, ease-in-out) }
[data-pt-loop="float-y"].pt-loop-active { animation-name: pt-float-y; animation-duration: var(--pt-ld, 2s); animation-timing-function: var(--pt-le, ease-in-out) }
[data-pt-loop="float-x"].pt-loop-active { animation-name: pt-float-x; animation-duration: var(--pt-ld, 2s); animation-timing-function: var(--pt-le, ease-in-out) }
@media (prefers-reduced-motion: reduce) {
  [data-pt-anim], [data-pt-emph], [data-pt-exit] { opacity: 1 !important; animation: none !important }
  [data-pt-hover] { transition: none !important }
  [data-pt-hover]:active { transform: none !important }
  [data-pt-loop]  { animation: none !important }
}`;

export function createAnimation(): SDKModule {
  let styleEl: HTMLStyleElement | null = null;
  let io: IntersectionObserver | null = null;
  let loopIo: IntersectionObserver | null = null;
  let exitIo: IntersectionObserver | null = null;
  let ac: AbortController | null = null;

  function injectStyles(): void {
    if (document.getElementById('pt-anim-styles')) return;
    styleEl = document.createElement('style');
    styleEl.id = 'pt-anim-styles';
    styleEl.textContent = ANIMATION_STYLE_CSS;
    document.head.appendChild(styleEl);
  }

  return {
    name: 'animation',
    init(_ctx: SDKContext): void {
      const w = window as Window & { __ptAnimInit?: boolean };
      if (w.__ptAnimInit) return;
      w.__ptAnimInit = true;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        injectStyles();
        return;
      }
      injectStyles();
      ac = new AbortController();
      document.documentElement.classList.add('pt-anim-ready');

      // stagger: accumulate delay on each animated child by DOM order (don't overwrite user-set)
      document.querySelectorAll<HTMLElement>('[data-pt-anim-stagger]').forEach((box) => {
        const step = parseInt(box.getAttribute('data-pt-anim-stagger') || '', 10) || 80;
        let i = 0;
        box.querySelectorAll<HTMLElement>('[data-pt-anim]').forEach((child) => {
          if (!child.style.getPropertyValue('--pt-dl')) child.style.setProperty('--pt-dl', i * step + 'ms');
          i++;
        });
      });

      const entered = new WeakSet<Element>();

      // emphasis: add trigger class; chain loop after emphasis ends (if finite)
      const startEmph = (el: HTMLElement): void => {
        el.classList.add('pt-emph-in');
        if (el.hasAttribute('data-pt-loop')) {
          const onEnd = (ev: AnimationEvent): void => { if (ev.target !== el) return; el.removeEventListener('animationend', onEnd as EventListener); el.classList.add('pt-loop-active'); };
          el.addEventListener('animationend', onEnd as EventListener, { signal: ac!.signal });
        }
      };

      // entrance: play once; on end chain emphasis (preferred) or loop
      const play = (el: HTMLElement): void => {
        el.style.willChange = 'transform, opacity';
        el.classList.add('pt-anim-in');
        const onEnd = (ev: AnimationEvent): void => {
          if (ev.target !== el) return;
          el.style.willChange = '';
          el.removeEventListener('animationend', onEnd as EventListener);
          if (el.hasAttribute('data-pt-emph')) startEmph(el);
          else if (el.hasAttribute('data-pt-loop')) el.classList.add('pt-loop-active');
        };
        el.addEventListener('animationend', onEnd as EventListener, { signal: ac!.signal });
      };

      // reveal: entrance + (pure) emphasis play once on first scroll-in; mark entered
      const revealTargets = document.querySelectorAll<HTMLElement>('[data-pt-anim], [data-pt-emph]');
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            const el = e.target as HTMLElement;
            entered.add(el);
            if (el.hasAttribute('data-pt-anim')) play(el);
            else if (el.hasAttribute('data-pt-emph')) startEmph(el);
            io!.unobserve(el);
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        revealTargets.forEach((el) => io!.observe(el));
      } else {
        revealTargets.forEach((el) => {
          if (el.hasAttribute('data-pt-anim')) el.classList.add('pt-anim-in');
          if (el.hasAttribute('data-pt-emph')) el.classList.add('pt-emph-in');
        });
      }

      // exit: after element has been in view, play once when it scrolls fully out
      const exitTargets = document.querySelectorAll<HTMLElement>('[data-pt-exit]');
      if (exitTargets.length && 'IntersectionObserver' in window) {
        exitIo = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const el = e.target as HTMLElement;
            if (e.isIntersecting) { entered.add(el); return; }
            if (entered.has(el) && !el.classList.contains('pt-exit-out')) {
              el.classList.add('pt-exit-out');
              exitIo!.unobserve(el);
            }
          });
        }, { threshold: 0 });
        exitTargets.forEach((el) => exitIo!.observe(el));
      }

      // loop: pure loops (no entrance & no emphasis) activate now; chains handled above; offscreen pause
      const loops = document.querySelectorAll<HTMLElement>('[data-pt-loop]');
      loops.forEach((el) => {
        if (!el.hasAttribute('data-pt-anim') && !el.hasAttribute('data-pt-emph')) el.classList.add('pt-loop-active');
      });
      if (loops.length && 'IntersectionObserver' in window) {
        loopIo = new IntersectionObserver((entries) => {
          entries.forEach((e) => { (e.target as HTMLElement).classList.toggle('pt-loop-paused', !e.isIntersecting); });
        }, { threshold: 0 });
        loops.forEach((el) => loopIo!.observe(el));
      }
    },
    destroy(): void {
      ac?.abort();
      ac = null;
      if (io) { io.disconnect(); io = null; }
      if (loopIo) { loopIo.disconnect(); loopIo = null; }
      if (exitIo) { exitIo.disconnect(); exitIo = null; }
      if (styleEl && styleEl.parentNode) styleEl.parentNode.removeChild(styleEl);
      styleEl = null;
      document.documentElement.classList.remove('pt-anim-ready');
      document.querySelectorAll<HTMLElement>('.pt-anim-in, .pt-emph-in, .pt-exit-out, .pt-loop-active, .pt-loop-paused').forEach((el) => {
        el.classList.remove('pt-anim-in', 'pt-emph-in', 'pt-exit-out', 'pt-loop-active', 'pt-loop-paused');
        el.style.willChange = '';
      });
      (window as Window & { __ptAnimInit?: boolean }).__ptAnimInit = undefined;
    },
  };
}
